import { render } from "./FinishScreen.vue?vue&type=template&id=64a80e16"
import script from "./FinishScreen.vue?vue&type=script&lang=js"
export * from "./FinishScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Apps/sdworks_reaction_game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__